import { render, staticRenderFns } from "./TaskCmlLinksSection.vue?vue&type=template&id=8396a07e&scoped=true"
import script from "./TaskCmlLinksSection.vue?vue&type=script&lang=js"
export * from "./TaskCmlLinksSection.vue?vue&type=script&lang=js"
import style0 from "./TaskCmlLinksSection.vue?vue&type=style&index=0&id=8396a07e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8396a07e",
  null
  
)

export default component.exports